import { gql } from '@apollo/client';

const appraiserFieldsFragment = gql`
  fragment AppraiserFields on AppraiserInfo {
    ExternalUserId
    UserLicense {
      Email
      Name
      SystemRole {
        Id
      }
    }
    ParticipationSummary {
      TotalAppraisals {
        Atl {
          CurrentAmount
        }
        Atm {
          CurrentAmount
        }
      }
      TotalEvents {
        Total {
          CurrentAmount
          AmountLimit
        }
        Atl {
          CurrentAmount
          AmountLimit
        }
        Atm {
          CurrentAmount
          AmountLimit
        }
      }
      ObserverTotalEvents {
        Atl {
          CurrentAmount
        }
        Atm {
          CurrentAmount
        }
      }
    }
    Company
    DesiredRole
    CurrentRole {
      Title
      Value
      AffiliationType
    }
    AtlAffiliation
    AtmAffiliation
    City
    State
    Country
    AdditionalInformation
    TimeZoneId
    DirectChannel
    Observation
    WillingToTravelToAfrica
    WillingToTravelToAsia
    WillingToTravelToAustralia
    WillingToTravelToEurope
    WillingToTravelToNorthAmerica
    WillingToTravelToSouthAmerica
    WillingToTravelToVirtual
    DomainExperiences {
      Domain
      YearsOfExperience
      Role
      HasDomainAccess
    }
  }
`;

export default appraiserFieldsFragment;
